const languages = [
  {
    name: "Arabic",
    code: "ar",
  },
  {
    name: "Bosnian (Latin)",
    code: "bs",
  },
  {
    name: "Bulgarian",
    code: "bg",
  },
  {
    name: "Catalan",
    code: "ca",
  },
  {
    name: "Chinese Simplified",
    code: "zh-Hans",
  },
  {
    name: "Chinese Traditional",
    code: "zh-Hant",
  },
  {
    name: "Croatian",
    code: "hr",
  },
  {
    name: "Czech",
    code: "cs",
  },
  {
    name: "Danish",
    code: "da",
  },
  {
    name: "Dutch",
    code: "nl",
  },
  {
    name: "English",
    code: "en",
  },
  {
    name: "Estonian",
    code: "et",
  },
  {
    name: "Finnish",
    code: "fi",
  },
  {
    name: "French",
    code: "fr",
  },
  {
    name: "German",
    code: "de",
  },
  {
    name: "Greek",
    code: "el",
  },
  {
    name: "Haitian Creole",
    code: "ht",
  },
  {
    name: "Hebrew",
    code: "he",
  },
  {
    name: "Hindi",
    code: "hi",
  },
  {
    name: "Hmong Daw",
    code: "mww",
  },
  {
    name: "Hungarian",
    code: "hu",
  },
  {
    name: "Indonesian",
    code: "id",
  },
  {
    name: "Icelandic",
    code: "is",
  },
  {
    name: "Italian",
    code: "it",
  },
  {
    name: "Japanese",
    code: "ja",
  },
  {
    name: "Korean",
    code: "ko",
  },
  {
    name: "Kiswahili",
    code: "sw",
  },
  {
    name: "Klingon",
    code: "tlh",
  },
  {
    name: "Latvian",
    code: "lv",
  },
  {
    name: "Lithuanian",
    code: "lt",
  },
  {
    name: "Malay",
    code: "ms",
  },
  {
    name: "Maltese",
    code: "mt",
  },
  {
    name: "Norwegian",
    code: "no",
  },
  {
    name: "Persian",
    code: "fa",
  },
  {
    name: "Polish",
    code: "pl",
  },
  {
    name: "Portuguese",
    code: "pt",
  },
  {
    name: "Querétaro Otomi",
    code: "otq",
  },
  {
    name: "Romanian",
    code: "ro",
  },
  {
    name: "Russian",
    code: "ru",
  },
  {
    name: "Serbian (Cyrillic)",
    code: "sr-Cyrl",
  },
  {
    name: "Serbian (Latin)",
    code: "sr-Latn",
  },
  {
    name: "Slovak",
    code: "sk",
  },
  {
    name: "Slovenian",
    code: "sl",
  },
  {
    name: "Spanish",
    code: "es",
  },
  {
    name: "Swedish",
    code: "sv",
  },
  {
    name: "Thai",
    code: "th",
  },
  {
    name: "Turkish",
    code: "tr",
  },
  {
    name: "Ukrainian",
    code: "uk",
  },
  {
    name: "Urdu",
    code: "ur",
  },
  {
    name: "Vietnamese",
    code: "vi",
  },
  {
    name: "Welsh",
    code: "cy",
  },
  {
    name: "Yucatec Maya",
    code: "yua",
  },
];

export default languages;
